// @mui
import {
  Stack,
  Grid,
  Button,
  Typography,
  Pagination,
  LinearProgress,
} from '@mui/material';
// hooks
import { useEffect, useState } from 'react';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { UserTableToolbar } from 'src/sections/@dashboard/user/list';
import ConfirmationDialog from '../../shared/ConfirmationDialog';
import { useCourses } from '../useCourses';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { CourseModal } from './CourseModal';
import { Course } from 'src/@types/Course';
import CourseCard from './CourseCard';

// ----------------------------------------------------------------------
const Sort_Options = ['all', 'acsending', 'descending'];

// ----------------------------------------------------------------------

export default function CourseList() {
  const {
    modalOpen,
    setModalOpen,
    filterName,
    filterRole,
    currentCourse,
    setCurrentCourse,
    filteredData,
    page,
    setPage,
    total,
    pageSize,
    loading,
    handleDeleteRow,
    handleEditRow,
    handleFilterName,
    getCourseList,
  } = useCourses();

  // client-side-pagination-list-pages: refetch on page/search change. Search is
  // debounced (350ms); page changes fetch immediately.
  useEffect(() => {
    const t = setTimeout(() => getCourseList().catch(console.error), filterName ? 350 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filterName]);

  const [confirmOpen, setConfirmOpen] = useState({ open: false, currentId: '' });

  return (
    <Stack>
      <HeaderBreadcrumbs
        heading="Course List"
        links={[
          { name: 'Dashboard', href: PATH_DASHBOARD.root },
          { name: 'Course List', href: PATH_DASHBOARD.courses.root },
        ]}
        action={
          <Button
            variant="contained"
            onClick={() => setModalOpen(true)}
            startIcon={<Iconify icon={'eva:plus-fill'} />}
          >
            New Course
          </Button>
        }
      />
      <UserTableToolbar
        small={true}
        placeholder="Search Course..."
        filterName={filterName}
        filterRole={filterRole}
        onFilterName={handleFilterName}
        onFilterRole={() => {}}
        optionsRole={Sort_Options}
      />
      {loading && <LinearProgress sx={{ my: 1 }} />}
      <Grid container>
        {filteredData.map((course: Course, index: number) => (
          <Grid
            spacing={1}
            key={course?.id}
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            rowSpacing={1}
            columnSpacing={1}
          >
            <CourseCard
              course={course}
              key={index}
              handleEditRow={() => handleEditRow(course)}
              handleDeleteRow={() =>
                setConfirmOpen({ open: true, currentId: course._id ? course._id : course.id })
              }
            />
          </Grid>
        ))}
        {!loading && filteredData.length === 0 && (
          <Stack width={'100%'} height="300px" alignItems={'center'} justifyContent="center">
            <Typography> No result for your search data</Typography>
          </Stack>
        )}
      </Grid>
      {total > pageSize && (
        <Stack alignItems="center" sx={{ my: 3 }}>
          <Pagination
            count={Math.ceil(total / pageSize)}
            page={page}
            onChange={(_e, p) => setPage(p)}
            color="primary"
          />
        </Stack>
      )}
      <CourseModal
        open={modalOpen}
        handleClose={() => {
          setModalOpen(false);
          getCourseList();
          setCurrentCourse(undefined);
        }}
        isEdit={currentCourse ? true : false}
        currentCourse={currentCourse}
      />
      <ConfirmationDialog
        headText={'Delete Course'}
        text={'Are You Sure You Need To Delete This Course'}
        isOpen={confirmOpen.open}
        onClose={() => {
          setConfirmOpen({ open: false, currentId: '' });
          getCourseList();
        }}
        confirmAction={() => handleDeleteRow(confirmOpen.currentId)}
        loading={false}
      />
    </Stack>
  );
}
